import styled, { css } from 'styled-components';
import { useEffect, useState } from 'react';
import AuctionListService, {
  ISearchList,
} from '../../../service/auction/AuctionList';

interface Props {
  width?: number;
  value: string;
  yPosition?: number;
  onClickItem: (item: ISearchList) => void;
}

function QuickSearchResult({ width, value, yPosition, onClickItem }: Props) {
  const [list, setList] = useState<ISearchList[]>([]);
  const fetchData = async (searchWord: string) => {
    try {
      if (searchWord.length === 0) return;
      const result = await AuctionListService.search(searchWord);
      setList(result.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchData(value);
  }, [value]);
  return (
    <Container $width={width} $yPosition={yPosition}>
      {value === '' ? (
        <Item className="no-hover">검색어를 입력해주세요.</Item>
      ) : list.length === 0 ? (
        <Item className="no-hover">검색 결과가 없습니다.</Item>
      ) : (
        list.map((item) => (
          <Item
            key={item.iidx}
            onMouseDown={(e) => {
              e.stopPropagation();
              onClickItem(item);
            }}
          >
            <ItemHeader>
              <CaseNo>
                {item.caseno}
                {!item.unitno || item.unitno === 'null' ? '' : item.unitno}
              </CaseNo>
              <BadgeWrapper>
                <Badge>{item.status}</Badge>
                <Badge $type={item.type}>
                  {' '}
                  {item.type === 'a' && '경매'}
                  {item.type === 'p' && '공매'}
                  {item.type === 'e' && '예정'}
                </Badge>
              </BadgeWrapper>
            </ItemHeader>
            <GrayText>{item.iaddr}</GrayText>
            <GrayText>{item.court}</GrayText>
          </Item>
        ))
      )}
    </Container>
  );
}

export default QuickSearchResult;

const Container = styled.div<{ $width?: number; $yPosition?: number }>`
  position: absolute;
  top: ${({ $yPosition }) =>
    $yPosition ? `${$yPosition}px` : 'calc(100%) - 8px'};
  /* top: calc(100% - 8px); */
  left: 0;
  z-index: 9999;

  width: ${({ $width }) => ($width ? `${$width}px` : '100%')};
  max-height: 400px;
  overflow-y: auto;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  border-radius: 16px;
  border: 1px solid #e1e2e4;
  background: #fff;
  box-shadow: 0 4px 15px 0 rgba(141, 149, 163, 0.25);
`;

const Item = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-bottom: 1px solid rgba(112, 115, 124, 0.16);

  cursor: pointer;
  &:hover {
    background-color: rgb(255, 254, 223);
  }

  &.no-hover {
    &:hover {
      background-color: transparent;
    }
  }

  &:first-of-type {
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
  }
  &:last-of-type {
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
  }

  :last-child {
    border-bottom: none;
  }
`;

const ItemHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

const CaseNo = styled.div`
  color: #222;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
  white-space: pre-wrap;
`;

const BadgeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

const Badge = styled.div<{ $type?: string }>`
  display: flex;
  padding: 2px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 999px;

  font-size: 13px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.26px;

  ${({ $type }) => {
    switch ($type) {
      case 'a':
        return css`
          background: #ffdbd6;
          color: #d84836;
        `;
      case 'p':
        return css`
          background: #deedff;
          color: #0c64ce;
        `;
      case 'e':
        return css`
          background: #fffce3;
          color: #d87300;
        `;
      default:
        return css`
          background: rgba(112, 115, 124, 0.08);
          color: rgba(55, 56, 60, 0.61);
        `;
    }
  }}
`;

const GrayText = styled.div`
  color: #616161;
  white-space: pre-wrap;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const Divider = styled.div`
  width: 100%;
  padding: 0 16px;
  height: 1px;
  background: rgba(112, 115, 124, 0.16);
`;
